import React, { FC } from "react";

interface Props {
  className?: string;
}

export const Heading: FC<Props> = ({ children, className }) => {
  return (
    <div className={className}>
      <h2 tw="font-base text-base tracking-[.09px]">{children}</h2>
      <div tw="bg-gradient-to-r from-[#a1dbff] via-[#ce8ec0] to-[#c557e0] w-10 h-1 mt-3" />
    </div>
  );
};
